import glam from 'glamorous';
import { Colors, BrandonGrotesque } from 'module/View/Common';

type LinkProps = {
  // isLast: boolean;
  isActive: boolean | null;
};

export const Link = glam.a<LinkProps>(p => ({
  color: Colors.dark,
  padding: `0.2rem 0`,
  display: 'inline-block',
  fontSize: `1.5rem`,
  fontFamily: BrandonGrotesque.regular,
  fontStyle: 'normal',
  fontWeight: 'normal',
  position: 'relative',
  '&:before': {
    content: `''`,
    position: 'absolute',
    zIndex: -1,
    left: 0,
    right: 0,
    bottom: 10,
    height: 10,
    background: '#ffec00',
    transitionDuration: '0.3s',
    transformOrigin: 'left center',
    transform: p.isActive ? 'scaleX(1)' : 'scaleX(0)',
  },
  '&:hover:before': {
    transform: 'scaleX(1)',
  },
  '&:hover': {
    fontStyle: 'normal',
    color: Colors.dark,
  },
}));



// WEBPACK FOOTER //
// ./src/module/View/Menu/Items/Link.s.ts